// removed by extract-text-webpack-plugin
module.exports = {"consentsWrapper":"d4c6ed5b","column":"_274d2190"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileLayout/ProfileDocumentation/RenderViewConsents/index.styl
// module id = 5090
// module chunks = 39